export const CONFIRM_RESET_CODE = "CONFIRM_RESET_CODE";
export const RECOVER_ACCOUNT = "RECOVER_ACCOUNT";
export const RECOVER_ACCOUNT_BY_EMAIL = "RECOVER_ACCOUNT_BY_EMAIL";
export const RECOVER_ACCOUNT_BY_TEXT = "RECOVER_ACCOUNT_BY_TEXT";
export const SELECT_RECOVERY_ACCOUNT = "SELECT_RECOVERY_ACCOUNT";
export const CHOOSE_RECOVERY_METHOD = "CHOOSE_RECOVERY_METHOD";
export const SET_RESET_CODE = "SET_RESET_CODE";
export const SET_NEW_PASSWORD = "SET_NEW_PASSWORD";
export const SEND_RECOVERY_TEXT = "SEND_RECOVERY_TEXT";

export const recoverAccountAction = user_data => ({
  type: RECOVER_ACCOUNT,
  payload: { user_data }
});

export const selectRecoveryAccountAction = profile => ({
  type: SELECT_RECOVERY_ACCOUNT,
  payload: { profile }
});

export const chooseRecoveryMethodAction = recoveryMethod => ({
  type: CHOOSE_RECOVERY_METHOD,
  payload: recoveryMethod
});

export const recoverAccountByEmailAction = email => ({
  type: RECOVER_ACCOUNT_BY_EMAIL,
  payload: email
});

export const recoverAccountByTextAction = phoneNumber => ({
  type: RECOVER_ACCOUNT_BY_TEXT,
  payload: phoneNumber
});

export const setNewPasswordAction = payload => ({
  type: SET_NEW_PASSWORD,
  payload: payload
});

export const setResetCodeAction = verificationCode => ({
  type: SET_RESET_CODE,
  payload: verificationCode
});

export function confirmResetCodeAction(values) {
  return {
    type: CONFIRM_RESET_CODE,
    payload: { values }
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/accountRecovery.actions.js